<div class="chip" *ngFor="let row of this.chipList">
  {{row}}
  <!--<span class="closebtn" (click)="onClick.emit($event(row))">&times;</span>-->
  <span class="closebtn" (click)="this.onClickEvent(row)">&times;</span>
</div>
